import { http } from './config'

export default {

  getLoadChecks: (id) => {
    return http.get(`load_checks/${id}`)
  },
  getLoadChecksbyLoadId: (loadId) => {
    return http.get(`load_checks/by_load_id/${loadId}`)
  },
  resendCheckout: (loadId, resend) =>{
    return http.post(`loads/${loadId}/checkout_sap/${resend}`)
  }
}